import { minutesToMilliseconds } from 'date-fns';
import {
  CurrentUserFragment,
  MeQuery,
  useMeQuery,
} from 'src/graphql/generated';
import { DefaultQueryOptions } from './types';

type QueryOptions<Data = MeQuery> = DefaultQueryOptions<MeQuery, Data>;

export const useUser = <Data = MeQuery['me']>(
  options?: Omit<QueryOptions<Data>, 'initialData' | 'queryKey' | 'select'> & {
    select?: (data: CurrentUserFragment) => Data;
  },
) => {
  const { select: userSelect, ...restOptions } = options ?? {};

  return useMeQuery(undefined, {
    select: (data) => {
      const user = data.me;
      // If user provided a custom select, apply it to the user data
      // Otherwise return user as-is
      return userSelect
        ? userSelect(user)
        : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          (user as unknown as Data);
    },
    staleTime: minutesToMilliseconds(5),
    ...restOptions,
  });
};
